<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import cookie from '@utils/cookie'
export default {
  name: 'app',
  data () {
    return {
    }
  },
  created () {
    const token = cookie.get('kg-client-token')
    const pathname = window.location.pathname
    console.log('routeName', pathname)
    if (!token && !['/sign/find-pass', '/sign/sign-up', '/trade-ledger'].includes(pathname)) {
      this.$router.push('/sign/sign-in')
    }
    const lang = cookie.get('lang') && localStorage.getItem('lang')
    if (!lang) {
      cookie.set('lang', 'en-us')
      localStorage.setItem('lang', 'zh')
    }
  }
}
</script>
